/**
 * 合并组件类名，同时丢弃 false、null 和 undefined。
 * 这里只处理静态字符串，避免基础组件依赖完整 CSS-in-JS 运行时。
 */
export function classNames(...values: Array<string | false | null | undefined>): string {
  return values.filter(Boolean).join(" ");
}
